import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Paper } from '@material-ui/core';
import LinearProgress from '@material-ui/core/LinearProgress';
import { getHistory } from '../../utils/history.util';
import { IAppSettingsDto } from '../../models/common';

export interface ExternalProps {
  children: any;
  isLoading: boolean;
  app_settings: IAppSettingsDto;
}

const useStyles = makeStyles({
  shrinkLogo: {
    maxWidth: 100,
    height: 'auto',
    margin: '0px auto',
    display: 'block',
  },
  container: {
    display: 'table',
    height: '100%',
    position: 'absolute',
    overflow: 'hidden',
    maxWidth: '100%',
    backgroundColor: 'transparent',
  },
  content: {
    margin: '0 auto',
    maxWidth: '100%',
    backgroundColor: '#242424',
  },
  header: {
    backgroundImage: 'url(' + `${process.env.PUBLIC_URL}/auth-header-bg.png` + ')',
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    borderRadius: '5px 5px 0px 0px',
  },
  main: {
    padding: '1.5rem',
  },
  bottomText: {
    marginTop: 5,
    textAlign: 'center',
    color: '#eee',
  },
});

function AuthLayout(props: ExternalProps) {
  const { children, isLoading, app_settings } = props;
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Paper className={classes.content} elevation={8}>
        <header className={classes.header} style={isLoading ? {} : { borderTop: '4px solid #C7A763' }}>
          {isLoading && <LinearProgress color='primary' style={{ borderRadius: '5px 5px 0px 0px' }} />}

          <img
            className={classes.shrinkLogo}
            alt='logo'
            src={`${process.env.PUBLIC_URL}/${app_settings.logo.url ? `./${app_settings.logo.url}` : './logo.png'}`}
            onClick={() => {
              getHistory().push('/login');
            }}
          />
        </header>
        <main className={classes.main}>{children}</main>
      </Paper>
    </div>
  );
}

export default AuthLayout;
